class SubscriptionPopup extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'fusion:subscription-popup';
    this.popup = this;
    this.classes = {
      bodyClass: 'subscription-modal-open',
      overlayCLass: 'overflow-hidden',
      activeClass: 'is-visible',
      closingClass: 'closing',
    };

    this.expiryDays = parseInt(this.dataset.expiry, 10) || 5;
    this.delaySeconds = parseInt(this.dataset.delay, 10);
    if (isNaN(this.delaySeconds)) this.delaySeconds = 2;
    this.homeOnly = this.dataset.homeOnly === 'true';

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.popup.classList.contains(this.classes.activeClass)) {
        this.close();
      }
    });

    if (this.querySelector('.form-success-message')) {
      this.setCookie(this.cookieName, 365);
      return;
    }

    if (this.querySelector('.alert-warning')) {
      this.open();
      return;
    }

    if (this.getCookie(this.cookieName)) {
      return;
    }

    if (this.homeOnly && !this.isHomepage()) {
      return;
    }

    this.init();
  }

  isHomepage() {
    const path = window.location.pathname.replace(/\/$/, '');
    return path === '' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
  }

  init() {
    if (!this.popup) return;

    this.timer = setTimeout(() => {
      this.open();
    }, this.delaySeconds * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    if (this.dataset.subscriptionpopup !== 'true') return;

    document.body.classList.add(this.classes.bodyClass);
    document.body.classList.add(this.classes.overlayCLass);
    this.popup.classList.add(this.classes.activeClass);

    this.setCookie(this.cookieName, this.expiryDays);
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);
    document.body.classList.remove(this.classes.overlayCLass);
    document.body.classList.remove(this.classes.bodyClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
    }, 500);

    this.setCookie(this.cookieName, this.expiryDays);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    const days = parseInt(expiry, 10) || 5;
    document.cookie = `${name}=true; max-age=${days * 24 * 60 * 60}; path=/; SameSite=Lax`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0; path=/`;
  }
}

customElements.define('subscription-popup', SubscriptionPopup);